import Paper, { PaperProps } from "@mui/material/Paper";
import * as React from "react";
import Draggable from "react-draggable";

function PaperComponent(props: PaperProps) {
  const nodeRef = React.useRef<HTMLDivElement | null>(null);

  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper ref={nodeRef} {...props} />
    </Draggable>
  );
}

export default PaperComponent;
